import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types/RootState';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state?.socketData || initialState;

export const selectPriceFeed = createSelector([selectDomain], (state) => state.priceFeed);
